import { makeStyles } from '@mui/styles';

export const useTableFooterStyle = makeStyles(() => ({
  paddingRight: {
    paddingRight: '20px',
  },
}));
